// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.warp[data-v-db87d850] .el-col {\n  height: 50px;\n}\n.iconEye[data-v-db87d850] {\n  cursor: pointer;\n  margin-left: 10px;\n}\n.warp[data-v-db87d850] .el-descriptions-item__label {\n  font-size: 13px;\n  color: #909399;\n}\n.warp[data-v-db87d850] .el-descriptions-item__cell {\n  /*height: 35px !important;*/\n  padding-bottom: 2px !important;\n}\n.el-descriptions-item__cell div[data-v-db87d850] {\n  font-weight: bold;\n  font-size: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
